"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onLoginStatusChange = void 0;
var utils_1 = require("../../../build-babel/auth/status/utils");
var sender_1 = require("../../../build-babel/auth/status/sender");
var onLoginStatusChange = function onLoginStatusChange(isLogin) {
  if ((0, utils_1.isIFrame)()) {
    (0, sender_1.sendPostMessage)({
      isLogin: isLogin
    }, (0, utils_1.getParentDomain)());
  }
};
exports.onLoginStatusChange = onLoginStatusChange;
//# sourceMappingURL=index.js.map